import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['priceField', 'originalPrice', 'discountedPrice', 'savings']

  connect() {
    this.calculateSavings()
  }

  calculateSavings() {
    let ticketPrice = parseFloat(this.ticketFormController.priceFieldTarget.value)
    if (!isNaN(ticketPrice)) {
      this.originalPriceTarget.innerHTML = this.formatCurrency(ticketPrice)
      let discountValue = parseFloat(this.priceFieldTarget.value)
      if (!isNaN(discountValue)) {
        // `.discounted-price` shows the early-bird PRICE (the value typed in the
        // price field), not the savings. Savings is surfaced separately below.
        this.discountedPriceTarget.innerHTML = this.formatCurrency(discountValue)
        let savings = Math.max(ticketPrice - discountValue, 0)
        if (this.hasSavingsTarget) this.savingsTarget.innerHTML = this.formatCurrency(savings)
      }
    }
  }

  get ticketFormController() {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === 'ticket-form'
    })
  }

  formatCurrency(amount) {
    return `$${parseFloat(amount).toFixed(2)}`
  }
}
